import {getLocaleDate, capitalizePersonName, getShiftedWeeks} from "../../utilities/general"

export const EducatorOrientationFields = ({orientation}) => {
    return (
        <div className="d-flex flex-row flex-wrap fw-semibold fs-6 gap-2 py-4">
            <span className="d-flex align-items-center me-5 mb-2">
                <i className={"fas text-primary fs-6 me-2 fa-hospital"}></i>
                {orientation.unit_name ? orientation.unit_name : "No Info"}
            </span>
            <span className="d-flex align-items-center me-5 mb-2">
                <i className={"fas text-primary fs-6 me-2 fa-user-nurse"}></i>
                {orientation.position_name ? orientation.position_name : "No Info"}
            </span>
            <span className="d-flex align-items-center me-5 mb-2">
                <i className={"fas text-primary fs-6 me-2 fa-clock-rotate-left"}></i>
                <span className="me-2">Prior Exp:</span>
                {orientation.experience_level_name ? orientation.experience_level_name : "No Info"}
            </span>
            <span className="d-flex align-items-center me-5 mb-2">
                <i className={"fas text-primary fs-6 me-2 fa-graduation-cap"}></i>
                {orientation.nursing_program_completed
                    ? `${orientation.nursing_program_completed} ${getLocaleDate(orientation.nurse_graduate_board_date)}`
                    : "No Info"}
            </span>
            <span className="d-flex align-items-center me-5 mb-2">
                <i className={"fas text-primary fs-6 me-2 fa-flag"}></i>
                <span className="me-2">Hired:</span>
                {orientation.hire_date ? getLocaleDate(orientation.hire_date) : "No Info"}
            </span>
            <span className="d-flex align-items-center me-5 mb-2">
                <i className={"fas text-primary fs-6 me-2 fa-flag"}></i>
                <span className="me-2">Started:</span>
                {orientation.start_date ? getLocaleDate(orientation.start_date) : "No Info"}
            </span>

            <span className="d-flex align-items-center me-5 mb-2">
                <i className="fas text-primary fs-6 me-2 fa-calendar-xmark"></i>
                <span className="me-2">Expected End Date:</span>
                {orientation.expected_end_date ? getLocaleDate(orientation.expected_end_date) : "No Info"}
            </span>
            <span className="d-flex align-items-center me-5 mb-2">
                <i className="fas text-primary fs-6 me-2 fa-calendar-xmark"></i>
                <span className="me-2">Length:</span>
                {orientation.standard_orientation_length_weeks
                    ? `${orientation.standard_orientation_length_weeks} weeks`
                    : "No Info"}                
                {orientation.educator_shifted_weeks ? (
                    <span className="ms-2">{getShiftedWeeks(orientation)}</span>
                ) : null}
            </span>
            <span className="d-flex align-items-center me-5 mb-2">
                <i className={"fas text-primary fs-6 me-2 fa-hospital-user"}></i>
                <span className="me-2">Preceptors:</span>
                {!orientation.preceptors || orientation.preceptors.length === 0
                    ? "No Preceptors Assigned"
                    : orientation.preceptors.map((p) => capitalizePersonName(p.preceptor_name)).join(", ")}
            </span>
        </div>
    )
}
